const glassPostfix = ['LUS', 'SZK'];

export const prepareFrontsList = (product, frontPatterns = {}) => {
  let frontsList = [];
  if (product.fronts) {
    if (product.is_hinged) {
      frontsList = Object.values(product.fronts).filter(
        side => side && side?.hasOwnProperty('safo'),
      );
    } else {
      frontsList = rebuildFronts(product.fronts, product.panels);
      if (!product.front_pattern) {
        if (frontPatterns[product.panels] ?? false) {
          product.front_pattern = frontPatterns[product.panels]['normal'];
        }
      }

      if (product.front_pattern) {
        let byPattern = product.front_pattern;
        let byPatternTmp2 = [];
        let byPattern2 = {};

        Object.entries(byPattern).forEach((value, key) => {
          const val = value[1].join(',');
          if (byPatternTmp2.indexOf(val) === -1) {
            byPattern2[value[0]] = value[1];
          }

          byPatternTmp2.push(val);
        });

        byPatternTmp2 = {};
        // korekta indeksów dla frontow
        Object.keys(byPattern2).forEach(key => {
          byPattern2[key].forEach(panelIdx => {
            const splitIndex = panelIdx.split('_');
            let panel = frontsList[splitIndex[1]][splitIndex[2]];
            if (panel !== undefined && panel !== null) {
              if (byPatternTmp2[key] === undefined) {
                byPatternTmp2[key] = {};
              }
              byPatternTmp2[key][panelIdx] = panel;
            }
          });
        });

        Object.keys(byPatternTmp2).forEach(key => {
          byPatternTmp2[key] = Object.values(byPatternTmp2[key]).pop();
        });

        frontsList = Object.values(byPatternTmp2);
      }
    }
  }

  return frontsList;
};

export const prepareHandlesList = product => {
  let handles = [];
  if (product.handles) {
    if (product.is_hinged) {
      handles = Object.values(product.handles);
    } else {
      handles.push(product.handles.left);
    }
  }

  return handles;
};

/**
 * Hamulec powinien być dodawany gdy ponad 50% powierzchni drzwi będzie ze szkła:
 * a) dla szafy niskiej - dwa lub 3 panele szklane na jednych drzwiach = obowiązkowy hamulec
 * b) dla szafy wysokiej - cztery panele szklane na jednych drzwiach = obowiązkowy hamulec.
 *
 * @param {*} product
 */
export const someFrontHasGlass = product => {
  let check = [];
  for (let i = 0; i < product.doors; i++) {
    if (product.is_hinged) {
      if (glassPostfix.some(el => product.fronts[i].safo.includes(el))) {
        return true;
      }
    } else {
      for (let p = 0; p < product.panels; p++) {
        if (check[i] === undefined) {
          check[i] = 0;
        }

        if (glassPostfix.some(el => product.fronts[i][p].safo.includes(el))) {
          check[i] += 1;
        }
      }
    }
  }

  if (product.is_hinged) {
    return false;
  } else {
    const condition = product.panels === 3 ? 2 : 4;
    for (let i = 0; i < product.doors; i++) {
      if (check[i] >= condition) {
        return true;
      }
    }

    return false;
  }
};

export const checkFreeAccessories = accessories => {
  const { forFree } = accessories;

  return forFree.free.map(item => {
    return {
      ...item,
      gratis: true,
      uId: Math.random(),
    };
  });
};

export const changePanelSafo = (panelObj, index, maxPanels) => {
  const isExternal = index === 0 || index === maxPanels;
  panelObj.safo = isExternal
    ? panelObj.safo.replace('/W-', '/Z-')
    : panelObj.safo.replace('/Z-', '/W-');
  panelObj.qty = 1;

  if (maxPanels === 2) {
    panelObj.qty = isExternal ? 2 : 1;
  } else {
    panelObj.qty = 2;
  }

  return panelObj;
};

export const changePriceForFronts = (fronts, safo, priceDefault) => {
  const list = fronts.find(item => item.safo === safo);
  return list ? list.price : priceDefault;
};

export const rebuildFronts = (fronts, panels, allFronts = []) => {
  const maxPanels = parseInt(panels) - 1;
  let newFronts = [[], []];
  fronts.forEach((doors, doorIx) => {
    if (doors) {
      doors.forEach((panel, panelIdx) => {
        if (panel && panel.hasOwnProperty('safo')) {
          let newPanel = changePanelSafo({ ...panel }, parseInt(panelIdx), maxPanels);
          if (allFronts) {
            newPanel.price = changePriceForFronts(allFronts, newPanel.safo, newPanel.price);
          }
          newFronts[doorIx][panelIdx] = newPanel;
        }
      });
    }
  });

  return newFronts;
};

// const getImageDimensions = file => {
//   return new Promise(function (resolved, rejected) {
//     var i = new Image();
//     i.src = file;
//     drawImage(i);
//   });
// };

// const drawImage = img => {
//   var canvas = document.createElement('canvas');
//   var ctx = canvas.getContext('2d');
//   ctx.drawImage(img, 0, 0);
//   // document.getElementsByTagName('body').innerHTML += canvas;
//   // document.querySelector('body').appendChild(ctx);

//   // var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
//   // var data = imageData.data;
//   // console.log(data.filter(r => r !== 255));
//   // const pixelLgh = imageData.data.length;
//   // let i;
//   // var bound = {
//   //   top: null,
//   //   left: null,
//   //   right: null,
//   //   bottom: null,
//   // };
//   // var x;
//   // var y;

//   // for (i = 0; i < pixelLgh; i += 4) {
//   //   if (data[i + 3]) {
//   //     // console.log(data[i + 3]);
//   //   }
//   // }
// };

// const getColorIndicesForCoord = (x, y, width) => {
//   const red = y * (width * 4) + x * 4;
//   return [red, red + 1, red + 2, red + 3];
// };

export const trimCanvas = async base64 => {
  // var dim = await getImageDimensions(base64);
  // var copy = document.createElement('canvas').getContext('2d');
  // const pixels = ctx.getImageData(0, 0, dim.w, dim.h);
  // console.log(pixels.data.length)
  // Iterate over every pixel to find the highest
  // and where it ends on every axis()
  // for (i = 0; i < l; i += 4) {
  //   if (pixels.data[i + 3]) {
  //     console.log(pixels.data[i + 3]);
  //     x = (i / 4) % dim.w;
  //     y = ~~(i / 4 / dim.h);
  //     console.log({ x, y })
  //     if (bound.top === null) {
  //       bound.top = y;
  //     }
  //     if (bound.left === null) {
  //       bound.left = x;
  //     } else if (x < bound.left) {
  //       bound.left = x;
  //     }
  //     if (bound.right === null) {
  //       bound.right = x;
  //     } else if (bound.right < x) {
  //       bound.right = x;
  //     }
  //     if (bound.bottom === null) {
  //       bound.bottom = y;
  //     } else if (bound.bottom < y) {
  //       bound.bottom = y;
  //     }
  // }
  // }
  // console.log(bound);
  // Calculate the height and width of the content
  // var trimHeight = bound.bottom - bound.top,
  //   trimWidth = bound.right - bound.left,
  //   trimmed = ctx.getImageData(bound.left, bound.top, trimWidth, trimHeight);
  // copy.canvas.width = trimWidth;
  // copy.canvas.height = trimHeight;
  // copy.putImageData(trimmed, 0, 0);
  // console.log(copy.canvas.toDataURL());
  // // Return trimmed canvas
  // return copy.canvas.toDataURL();
};
